type FunnelDevConversionData = {
  locale: string
  isFreelancer: boolean
  devPower: string
  jobTypes: string[]
  jobLengths: string[]
}

type FunnelCompanyConversionData = {
  locale: string
  company: string
  role: string
  stepsCompleted: number
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

const pushToDataLayer = (event: string, data: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...data })
}

export const trackFunnelDevConversion = (data: FunnelDevConversionData) => {
  pushToDataLayer("funnel_dev_conversion", {
    funnel_type: "dev",
    locale: data.locale,
    is_freelancer: data.isFreelancer,
    dev_power: data.devPower,
    job_types: data.jobTypes,
    job_lengths: data.jobLengths,
  })
}

export const trackFunnelCompanyConversion = (
  data: FunnelCompanyConversionData
) => {
  pushToDataLayer("funnel_company_conversion", {
    funnel_type: "company",
    locale: data.locale,
    company: data.company,
    role: data.role,
    steps_completed: data.stepsCompleted,
  })
}
